// extracted by mini-css-extract-plugin
export default {"order":"order-details_order__6c9F-","icon":"order-details_icon__C+h8a"};